// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32Yjq","right":"styles_right__3qaxQ"};